module.exports = __webpack_public_path__ + "static/media/checklist_512.000f6eea.png";